import { Link } from "react-router-dom";
import { Shield, Globe } from "lucide-react";
import { useTranslation } from "@/hooks/useTranslation";
import { APP_DEFAULT_LOGO_SRC } from "@/components/layout/AppShellBrand";

export function ModernFooter() {
  const { t } = useTranslation();

  return (
    <footer className="bg-[#FDFBF7] border-t border-[#E5DDD2]" aria-label="Pied de page" data-marketing-footer>
      <div className="max-w-7xl mx-auto px-4 py-16">
        <div className="grid lg:grid-cols-4 gap-8">
          {/* Logo & Description */}
          <div className="lg:col-span-1">
            <div className="mb-6">
              <img
                src={APP_DEFAULT_LOGO_SRC}
                alt="Stratelya"
                className="h-10 w-auto max-w-[168px] object-contain object-left"
              />
            </div>
            <p className="text-[#5C5C5C] text-sm leading-relaxed">
              {t('publicFooter.description')}
            </p>
          </div>

          {/* Product */}
          <div>
            <h3 className="text-[#001B3D] font-semibold mb-6">{t('publicFooter.product.title')}</h3>
            <ul className="space-y-3">
              <li><Link to="/contact" className="text-[#5C5C5C] hover:text-[#B38E5D] transition-colors">{t('publicFooter.product.pricing')}</Link></li>
              <li><Link to="/dashboard" className="text-[#5C5C5C] hover:text-[#B38E5D] transition-colors">{t('publicFooter.product.dashboard')}</Link></li>
              <li><Link to="/aide" className="text-[#5C5C5C] hover:text-[#B38E5D] transition-colors">{t('publicFooter.product.help')}</Link></li>
            </ul>
          </div>

          {/* Entreprise */}
          <div>
            <h3 className="text-[#001B3D] font-semibold mb-6">{t('publicFooter.company.title')}</h3>
            <ul className="space-y-3">
              <li><Link to="/about" className="text-[#5C5C5C] hover:text-[#B38E5D] transition-colors">{t('publicFooter.company.about')}</Link></li>
              <li><Link to="/contact" className="text-[#5C5C5C] hover:text-[#B38E5D] transition-colors">{t('publicFooter.company.contact')}</Link></li>
              <li><Link to="/use-cases" className="text-[#5C5C5C] hover:text-[#B38E5D] transition-colors">Expertises</Link></li>
            </ul>
          </div>

          {/* Légal */}
          <div>
            <h3 className="text-[#001B3D] font-semibold mb-6">{t('publicFooter.legal.title')}</h3>
            <ul className="space-y-3">
              <li><Link to="/privacy" className="text-[#5C5C5C] hover:text-[#B38E5D] transition-colors">{t('publicFooter.legal.privacy')}</Link></li>
              <li><Link to="/terms" className="text-[#5C5C5C] hover:text-[#B38E5D] transition-colors">{t('publicFooter.legal.terms')}</Link></li>
              <li><Link to="/cookies" className="text-[#5C5C5C] hover:text-[#B38E5D] transition-colors">{t('publicFooter.legal.cookies')}</Link></li>
            </ul>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="border-t border-[#E5DDD2] pt-8 mt-6">
          <div className="flex flex-col lg:flex-row justify-between items-center gap-4">
            <div className="mb-2 flex flex-col gap-3 text-center sm:flex-row sm:items-center sm:gap-6 lg:mb-0 sm:text-start">
              <p className="text-[#5C5C5C] text-sm">{t('publicFooter.copyright')}</p>
              <div className="flex flex-wrap items-center justify-center sm:justify-start gap-x-4 gap-y-2">
                <Link to="/privacy" className="text-[#5C5C5C] hover:text-[#B38E5D] text-sm transition-colors">{t('publicFooter.legal.privacy')}</Link>
                <Link to="/terms" className="text-[#5C5C5C] hover:text-[#B38E5D] text-sm transition-colors">{t('publicFooter.legal.terms')}</Link>
                <Link to="/cookies" className="text-[#5C5C5C] hover:text-[#B38E5D] text-sm transition-colors">{t('publicFooter.legal.cookies')}</Link>
              </div>
            </div>
            <div className="flex flex-wrap items-center justify-center gap-3">
              <div className="flex items-center gap-2">
                <Shield className="w-4 h-4 text-[#B38E5D]" aria-hidden="true" />
                <span className="text-sm text-[#5C5C5C]">{t('publicFooter.security.ssl')}</span>
              </div>
              <div className="flex items-center gap-2">
                <Globe className="w-4 h-4 text-[#001B3D]" aria-hidden="true" />
                <span className="text-sm text-[#5C5C5C]">{t('publicFooter.security.gdpr')}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
